import React from "react";

// core components
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import AccountInfoCard from "./AccountInfoCard.jsx";
import RefCodeCard from "./RefCodeCard.jsx";
import AccountInfoCardForm from "./AccountInfoCard/AccountInfoCardForm.jsx";
import { connectedComponent } from "common/components/connectedComponent.js";
import ServiceEmailAddressesComponent from "./ServiceEmailAdresses.jsx";
import SurveyModal from "../Rating/SurveyModal.jsx";

import loadContent from "core-module/hoc/loadContent";

class Account extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shouldEdit: false,
      userInfo: {
        name: this.props.getData("name"),
        name2: this.props.getData("name2"),
        phoneNumbers: this.props.getData("phonenumbers"),
        emailAddresses: this.props.getData("emailaddresses"),
        address: {
          address: this.props.getData("address"),
          postalCode: this.props.getData("postalcode"),
          city: this.props.getData("city"),
          province:
            this.props.getData("regionid") == 1
              ? "AB"
              : this.props.getData("regionid") == 2
              ? "SK"
              : "-",
        },
      },
    };
  }

  render() {
    const handleEditMode = () => {
      this.setState({ shouldEdit: this.state.shouldEdit ? false : true });
    };

    return (
      <div>
         <SurveyModal />
        {!this.state.shouldEdit ? (
          <GridContainer>
            <GridItem xs={12} lg={6}>
              <RefCodeCard />
              <ConnectedServiceEmailAddressesComponent
                pathids={{ user: this.props.getData("id") }}
                loggedAs={this.props.sessionids.email}
              />
            </GridItem>
            <GridItem xs={12} lg={6}>
              <AccountInfoCard editMode={handleEditMode} />
            </GridItem>
          </GridContainer>
        ) : (
          <GridContainer justify="center">
            <GridItem xs={12} lg={6}>
              <AccountInfoCardForm
                userInfo={this.state.userInfo}
                editMode={handleEditMode}
              />
            </GridItem>
          </GridContainer>
        )}
      </div>
    );
  }
}

export default loadContent("user.session", Account);

const ConnectedServiceEmailAddressesComponent = connectedComponent(
  ServiceEmailAddressesComponent,
  {
    path: "user.id/serviceemail",
  }
);
